module.exports = __webpack_public_path__ + "static/media/quarter_8th.661d920f.png";